import type { DSImageProps } from 'shared-definitions/types'
import type { SgBadge } from 'lib/dealhunt/types'

/**
 * Adapt a DealHunt `SgBadge` (a single remote shield URL) into the `DSImageProps`
 * shape `AppImage` expects, so the product hero / card render badges through the
 * same `<picture>` path as review-post images (`shared-components/ui/ImageBlock`).
 *
 * DealHunt has no `srcSet`/`webp` variants for badge graphics, so those stay null
 * and `AppImage` falls back to a plain `<img>` from `src` — visually identical to
 * the previous bare `<img>`, just on the shared rendering path. If badge variants
 * are ever added to the DealHunt payload, populate them here.
 */
export function badgeToImage(badge: SgBadge): DSImageProps {
  return {
    src: badge.imageUrl ?? '',
    alt: badge.label,
    title: null,
    srcSet: null,
    webpSrcSet: null,
    caption: null,
    credits: [],
    size: null,
  }
}
